import { fetchQuery_DEPRECATED as fetchQuery, graphql } from 'react-relay/legacy';
import get from 'lodash.get';

// TODO: go back to using fetchUserMetadata from contactDealerAuthHandler once disabler is resolved https://1stdibs.atlassian.net/browse/ENGAGE-1096
const userMetadataQuery = graphql`
    query fetchUserMetadataQuery($email: String = "") {
        viewer {
            disableCompleteAccountEmail: isEnabled(key: "disableCompleteAccountEmail")
            userExistsMetadata(email: $email) {
                userExists
                emailOnly
                hasPassword
            }
        }
    }
`;

export const fetchUserMetadata = (emailField, environment) => {
    return fetchQuery(environment, userMetadataQuery, {
        email: emailField,
    }).then(data => get(data, 'viewer') || {});
};
